<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-account
      </v-icon> My Profile
    </h2>
    <br>
    <v-card color="#CFD8DC">
      <br>
      <div
        v-if="isUserDetailsAvailable"
        class="user-div"
      >
        <p class="user-content">
          Company Details:- <font class="font-my-style">
            {{ userDetails.company.company_name }}
          </font>
        </p>
        <p class="user-content">
          Category:- <font
            v-if="userDetails.contractor_category !== null"
            class="font-my-style"
          >
            {{ userDetails.contractor_category.name }}
          </font>
          <font v-else>
            N/A
          </font>
        </p>
        <p class="user-content">
          Check-In Types:-<font
            class="font-my-style"
          >
            {{ userDetails.type | arrangePretty }}
          </font>
        </p>
      </div>
      <v-card
        class="card-style"
        color="#ECEFF1"
        :style="getBgStyle"
      >
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-text-field
              v-model="formData.firstName"
              label="First Name*"
              dense
              :rules="[(v) => !!v || 'This field is required']"
              filled
              color="#000000"
              light
              outlined
              class="purple-input"
            />
            <v-text-field
              v-model="formData.lastName"
              label="Last Name*"
              filled
              :rules="[(v) => !!v || 'This field is required']"
              color="#000000"
              dense
              outlined
              light
              class="purple-input"
            />
            <v-text-field
              v-model="formData.phoneNumber"
              label="Mobile"
              filled
              :rules="[(v) => !!v || 'This field is required']"
              color="#000000"
              outlined
              dense
              disabled
              hint="Please contact support for number change."
              persistent-hint
              light
              class="purple-input"
            />
            <v-text-field
              v-model="formData.email"
              label="Email Address*"
              outlined
              :rules="[(v) => !!v || 'This field is required']"
              color="#000000"
              filled
              dense
              class="purple-input"
              light
            />
          </v-form>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="#37474F"
              @click="cancel()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="#FF3700"
              @click="updateUserDetails()"
            >
              Update
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card-text>
      </v-card>
      <br>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-container>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';

export default {
  name: 'UserProfile',
  components: {
    'centre-spinner': spinner,
  },
  filters: {
    arrangePretty (val) {
      return val.join(', ');
    },
  },
  data: () => ({
    formData: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: null,
    },
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
    valid: false,
  }),
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    userDetails () {
      return this.$store.getters['userprofile/getUserDetails'];
    },
    isUserDetailsAvailable () {
        if (Object.keys(this.userDetails).length > 0) {
            return true;
        }
        return false;
    },
  },
  async mounted () {
    await this.fetchUserDetails();
  },
  methods: {
    async fetchUserDetails () {
        this.loading = true;
        await this.$store.dispatch('userprofile/fetchUserDetails').then(response => {
            this.fillData();
            this.loading = false;
        }).catch(() => {
            this.loading = false;
        });
    },
    fillData () {
        this.formData.firstName = this.userDetails.first_name;
        this.formData.lastName = this.userDetails.last_name;
        this.formData.email = this.userDetails.email;
        this.formData.phoneNumber = this.userDetails.phone_number;
    },
    updateUserDetails () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      this.$store.dispatch('userprofile/updateUserDetails', {
        details: {
          first_name: this.formData.firstName,
          last_name: this.formData.lastName,
          email_id: this.formData.email,
        },
      }).then(response => {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
            message: 'User details updated successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
        });
      }).catch(errors => {
        this.loading = false;
      });
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 25px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.user-content {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  margin-left: 10px;
  font-family:'Times New Roman', Times, serif;
}
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
  text-transform: capitalize;
}
.user-div {
  line-height:normal;
  margin-left: 10px;
  border-left: 3px solid #FF3700;
}
</style>
